import Box from 'components/shared/Box'
import { useState } from 'react'
import { OpeningHoursDto } from 'store/api-slice/hooks'
// eslint-disable-next-line no-restricted-imports
import MobileComponent from '../MobileHours'
import Text from 'components/shared/Text'
import { FormattedMessage } from 'react-intl'

interface SectionProps {
    seasons: OpeningHoursDto[]
}
const MobileSection = ({ seasons }: SectionProps) => {
    const [openedTabIndex, setOpenedTabIndex] = useState<string | null>(null)

    const seasonalHours = seasons.filter(
        (season) => !season.isSpecial && !season.isDefaultSpecial
    )
    const specialHours = seasons.filter((season) => season.isDefaultSpecial)

    return (
        <Box gap={24} isFullWidth>
            <Box gap={16} isFullWidth>
                {seasonalHours.length ? (
                    <>
                        {seasonalHours.map((season, index) => (
                            <MobileComponent
                                season={season}
                                key={`${index}seasonalHours`}
                                id={`seasonalHours${index}`}
                                isOpened={
                                    openedTabIndex === `seasonalHours${index}`
                                }
                                setOpenedTabIndex={setOpenedTabIndex}
                            />
                        ))}
                    </>
                ) : null}
                {specialHours.length ? (
                    <>
                        <Text variant="heading4" color="secondary_500" pt={16}>
                            <FormattedMessage
                                id="global.modal.opening_hours_holidays_title"
                                defaultMessage="Godziny otwarcia w <span>dni świąteczne</span>"
                                values={{
                                    span: (chunks: string[]) => (
                                        <Text
                                            as="span"
                                            variant="heading4"
                                            color="primary_500"
                                        >
                                            {chunks}
                                        </Text>
                                    ),
                                }}
                            />
                        </Text>
                        {specialHours.map((season, index) => (
                            <MobileComponent
                                season={season}
                                key={`${index}specialHours`}
                                id={`specialHours${index}`}
                                isOpened={
                                    openedTabIndex === `specialHours${index}`
                                }
                                setOpenedTabIndex={setOpenedTabIndex}
                            />
                        ))}
                    </>
                ) : null}
            </Box>
        </Box>
    )
}

export default MobileSection
